import React, { useState } from "react";
import { TextField, Chip } from "@mui/material";
import { isValNull } from "../../utils";

const stringToArray = (str) => {
  if (isValNull(str)) {
    return [];
  }
  const arr = str.split(",").map((item) => item.trim());
  return arr;
};

const ChipsInput = ({ initialValue = [], onChange, label, ...otherProps }) => {
  const [inputValue, setInputValue] = useState("");
  const [chips, setChips] = useState(initialValue);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleInputKeyPress = (event) => {
    if (event.key === "Enter" && inputValue.trim() !== "") {
      const value = [...chips, inputValue.trim()];
      setChips(value);
      onChange && onChange(value);
      setInputValue("");
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const pastedText = (event.clipboardData || window.clipboardData).getData(
      "text"
    );
    const value = stringToArray(pastedText);
    setChips((prev) => [...prev, ...value]);
  };

  const handleChipDelete = (chipToDelete) => () => {
    const value = (chips) => chips.filter((chip) => chip !== chipToDelete);
    setChips(value);
    onChange && onChange(value);
  };

  return (
    <div>
      <TextField
        sx={{
          "& .MuiInputBase-input": {
            padding: "8px !important",
          },
        }}
        {...otherProps}
        value={inputValue}
        onChange={handleInputChange}
        onKeyPress={handleInputKeyPress}
        onPaste={handlePaste}
        label={label}
        fullWidth
      />
      <div style={{ marginTop: "10px" }}>
        {chips.map((chip, index) => (
          <Chip
            key={index}
            label={chip}
            onDelete={handleChipDelete(chip)}
            style={{ marginRight: "5px", marginBottom: "5px" }}
          />
        ))}
      </div>
    </div>
  );
};

export default ChipsInput;
